/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BatteryFixedVoltages, UnitType } from 'src/api';
import { SharedModule } from '../../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { InputType } from '@ansys-internal/awc-angular/forms';
import {TooltipDirective} from "@ansys-internal/awc-angular/tooltip";
export type SetPart = [value: string, type: string, id: string, index?: number];

@Component({
    selector: 'app-battery-inputs',
    templateUrl: './battery.component.html',
    styleUrls: ['../inputs.scss'],
    imports: [SharedModule, CommonModule]
})
export class BatteryComponent {
  @Input() part!: BatteryFixedVoltages;
  @Input() update!: boolean;
  @Input() readonly!: boolean;
  @Output() setPart: EventEmitter<SetPart> = new EventEmitter<SetPart>();
  protected UnitType = UnitType;
  protected InputTypes = InputType;
}
